import React from 'react';
import {useParams} from 'react-router-dom';
import {useTranslation} from '../../hook/useTranslation';
import LayoutAbstract from './abstract/Abstract';
import LayoutEntity from './entity/Entity';
import LayoutIntro from './intro/Intro';
import LayoutModel from './model/Model';
import LayoutText from './text/Text';

export default function LayoutType() {
    const i18n = useTranslation();
    const {translationPath} = useParams<'translationPath'>();
    const layout = i18n.translate(`show.items.${translationPath}.layout`);

    return (
        <>
            {(layout === 'intro') && (
                <LayoutIntro/>
            )}
            {(layout === 'abstract') && (
                <LayoutAbstract/>
            )}
            {(layout === 'model') && (
                <LayoutModel/>
            )}
            {(layout === 'entity') && (
                <LayoutEntity/>
            )}
            {(layout === 'text') && (
                <LayoutText/>
            )}
        </>
    );
};
